interface HeroSectionProps {
  recipientName: string;
  onReveal: () => void;
  isRevealed: boolean;
}

export function HeroSection({ recipientName, onReveal, isRevealed }: HeroSectionProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-8 relative z-10">
      {!isRevealed && (
        <div className="text-center max-w-2xl fade-in w-full">
          <h1 className="font-serif text-3xl sm:text-4xl md:text-6xl text-text-primary mb-4 sm:mb-6">
            Для {recipientName},
          </h1>
          <p className="font-sans text-base sm:text-lg md:text-xl text-text-secondary leading-relaxed mb-6 sm:mb-8 px-2">
            в холодные зимние дни позволь себе это тепло и расслабление.
            <br />
            С Новым годом — пусть он будет наполнен заботой о себе!
          </p>
          <button
            onClick={onReveal}
            className="px-6 sm:px-8 py-3 sm:py-4 bg-warm-gold text-white text-sm sm:text-base font-semibold rounded-full 
                       hover:bg-opacity-90 transition-all glow"
          >
            Открыть подарок
          </button>
        </div>
      )}
    </div>
  );
}
